export default "__VITE_ASSET__D4u5T4Td__"